<div class="w-full h-full flex flex-col items-center justify-center bg-white gap-5 p-6 rounded-lg">
    <img class="logout-icon" src="assets/svgs/logout.svg" alt="logout">
    <div class="my-4 w-full">
        <p class="text-black text-center text-[20px]">{{ 'PROFILE.LOGOUT_NOW' | translate }}...</p>
        <p class="text-black text-center text-[20px]">{{ 'PROFILE.ARE_YOU_SURE' | translate }}?</p>
    </div>
    <div class="flex flex-col justify-between space-y-3 pt-3 w-full">
        <button
            (click)="onCancel()"
            class="w-full flex justify-center items-center gap-3 rounded-lg bg-blue-500 px-4 py-2 text-white hover:bg-blue-400 focus:outline-none focus:ring-1 focus:ring-blue-400 text-[20px]"
        >
        {{ 'PROFILE.NO' | translate }}
        </button>
        <button
            (click)="onConfirm()"
            class="w-full rounded-lg border border-blue-500 px-4 py-2 text-blue-500 hover:bg-blue-200 focus:outline-none focus:ring-1 focus:ring-blue-300 text-[20px]"
        >
            {{ 'PROFILE.YES' | translate }}
        </button>
    </div>
</div>
